import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/visaService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class VisaEditForm extends Form {
  state = {
    expiryDate: new Date(),
    passportExpiryDate: new Date(),
    daily_salary_options: [
      { id: "", name: "Select option" },
      { id: 0, name: "No" },
      { id: 1, name: "Yes" },
    ],
    salary_type_options: [
      { id: "", name: "Select option" },
      { id: "fixed", name: "Fixed" },
      { id: "hourly", name: "Hourly" },
    ],
    report_link_options: [
      { id: "", name: "Select option" },
      { id: "yes", name: "Yes" },
      { id: "no", name: "No" },
    ],
    show_in_ledger_when_close_options: [
      { id: "", name: "Select option" },
      { id: 1, name: "Yes" },
      { id: 0, name: "No" },
    ],
    expiry_duration_options: [
      { id: "", name: "Select option" },
      { id: "one-year", name: "One Year" },
      { id: "two-year", name: "Two Year" },
      { id: "three-year", name: "Three Year" },
    ],
    data: {
      cost: "",
      passport_number: "",
      identification_id: "",
      mobile: "",
      name: "",
      ref_name: "",
      ref_mobile: "",
      daily_salary_entry: "",
      salary_type: "",
      salary: "",
      expiry_duration_options: "",
      report_link: "",
      show_in_ledger_when_close: "",
    },
    errors: {},
  };

  schema = {
    cost: Joi.number().required().label("Cost"),
    passport_number: Joi.string().required().label("Passport"),
    identification_id: Joi.allow("").label("Emirates ID"),
    mobile: Joi.string().required().label("Mobile"),
    name: Joi.string().required().label("Name"),
    ref_name: Joi.string().label("Reference name"),
    ref_mobile: Joi.string().label("Reference mobile"),
    daily_salary_entry: Joi.number().required().label("Daily salary entry"),
    salary_type: Joi.string().allow("").label("Salary type"),
    salary: Joi.number().allow("").label("Salary"),
    expiry_duration_options: Joi.string().required().label("Expiry duration"),
    report_link: Joi.string().allow("").label("Report Link"),
    show_in_ledger_when_close: Joi.string()
      .allow("")
      .label("show in ledger when close option"),
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      const dateData = this.mapingData(account);

      //alert(dateData.expiryDate);

      this.setState({
        expiryDate:
          dateData.expiryDate != "01/01/1970" &&
          dateData.expiryDate != undefined &&
          dateData.expiryDate != ""
            ? new Date(dateData.expiryDate)
            : "",
        passportExpiryDate:
          dateData.passportExpiryDate != "01/01/1970" &&
          dateData.passportExpiryDate != undefined &&
          dateData.passportExpiryDate != ""
            ? new Date(dateData.passportExpiryDate)
            : "",
      });

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapingData(account) {
    return {
      expiryDate: account.expiry_date,
      passportExpiryDate: account.passport_expiry_date,
    };
  }
  mapToViewModel(account) {
    return {
      cost: account.cost,
      passport_number: account.passport_number,
      identification_id: account.identification_id,
      mobile: account.mobile,
      name: account.name,
      ref_name: account.ref_name,
      ref_mobile: account.ref_mobile,
      daily_salary_entry: account.daily_salary_entry,
      salary_type: account.salary_type ? account.salary_type : "",
      salary: account.salary ? account.salary : "",
      expiry_duration_options: account.expiry_duration,
      report_link: account.report_link ? account.report_link : "",
      show_in_ledger_when_close: account.show_in_ledger_when_close,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });

      let event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      //formData.append("expiry_date", date);
      // formData.append("_method", "PUT");

      data.expiry_date = date;

      event = new Date(this.state.passportExpiryDate);
      date = JSON.stringify(event);
      date = date.slice(1, 11);
      //formData.append("expiry_date", date);
      // formData.append("_method", "PUT");

      data.passport_expiry_date = date;

      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/visas-accounts");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.cost)
          errors.cost = ex.response.data.errors.cost;

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.ref_name)
          errors.ref_name = ex.response.data.errors.ref_name;

        if (ex.response.data.errors.ref_mobile)
          errors.ref_mobile = ex.response.data.errors.ref_mobile;

        if (ex.response.data.errors.daily_salary_entry)
          errors.daily_salary_entry =
            ex.response.data.errors.daily_salary_entry;

        if (ex.response.data.errors.salary_type)
          errors.salary_type = ex.response.data.errors.salary_type;

        if (ex.response.data.errors.salary)
          errors.salary = ex.response.data.errors.salary;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  handlePassportChangeExpiry = (date) => {
    this.setState({
      passportExpiryDate: date,
    });
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/visa.png";
    const { keyword, status } = queryString.parse(this.props.location.search);

    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update visa account</h1>

        <Link
          to={`/visas-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update visa account</h3>
              <p>Provide the information below to update the account.</p>
              {this.renderInput("cost", "Loan", "text")}
              {this.renderInput("passport_number", "Passport", "text")}
              {this.renderInput("identification_id", "Emirates Id", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("ref_name", "Reference Name", "text")}
              {this.renderInput("ref_mobile", "Reference Mobile", "text")}
              {this.renderSelect(
                "daily_salary_entry",
                "Daily Salary Entry",
                this.state.daily_salary_options
              )}

              {this.renderSelect(
                "salary_type",
                "Salary Type",
                this.state.salary_type_options
              )}
              {this.renderInput("salary", "Salary", "text")}

              <label>Visa Renewal Date</label>

              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />

              {this.renderSelect(
                "expiry_duration_options",
                "Renewal Duration",
                this.state.expiry_duration_options
              )}

              <label>Passport Expiry Date</label>

              <DatePicker
                selected={this.state.passportExpiryDate}
                onChange={this.handlePassportChangeExpiry}
                className="input"
              />

              {this.renderSelect(
                "report_link",
                "Report Link",
                this.state.report_link_options
              )}

              {this.renderSelect(
                "show_in_ledger_when_close",
                "Show in ledger when close",
                this.state.show_in_ledger_when_close_options
              )}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default VisaEditForm;
